import * as React from "react";

const ReadOauth = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <path d="M14 16h32v32H14z" />
      <path
        d="M30.867 29.333A7.988 7.988 0 0 0 23.333 24c-4.413 0-8 3.587-8 8s3.587 8 8 8c3.48 0 6.44-2.227 7.534-5.333h5.8V40H42v-5.333h2.667v-5.334h-13.8zm-7.534 5.334A2.675 2.675 0 0 1 20.667 32c0-1.467 1.2-2.667 2.666-2.667C24.8 29.333 26 30.533 26 32c0 1.467-1.2 2.667-2.667 2.667z"
        fill="#7B838C"
        fillRule="nonzero"
      />
      <g fill="#D2D5D8">
        <path d="M48 23.515L56.485 32 48 40.485z" />
      </g>
    </g>
  </svg>
);

export default ReadOauth;

